import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonApiService {
  private baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {}

  getUrl(endpoint: string) {
    return `${this.baseUrl}/${endpoint}`;
  }

  getRequest<T>(endpoint: string, extraParams?: { [k: string]: any }) {
    return this.http.get<T>(this.getUrl(endpoint), {
      params: this.prepareLocationUrlParams(extraParams),
    });
  }

  postRequest<T>(url: string, data: object) {
    return this.http.post<T>(`${this.getUrl(url)}`, data, {
      params: this.prepareLocationUrlParams(),
    });
  }

  getHttpClient() {
    return this.http;
  }

  handleError(e): Observable<any> {
    throw e.error;
  }

  /**
   * Method to concatenate all the query strings params for the URL
   */
  private prepareLocationUrlParams(extraParams?: { [k: string]: any }) {
    const httpParams: { [k: string]: any } = extraParams ? { ...extraParams } : {};

    if (environment.apiEndpointParams) {
      Object.keys(environment.apiEndpointParams).map(key => {
        httpParams[key] = environment.apiEndpointParams[key];
        if (key === 'test' && environment.apiEndpointParams[key]) {
          httpParams.timestamp = '' + (Date.now() - 3000);
        }
      });
    }
    return httpParams;
  }
}
